import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { BookingWithDisabledPropType } from "@models/components/booking.model";
import appSlice from "@slices/app.slice";
import { RootState } from "@store/index";

const BookingCalendarToggle: React.FC<BookingWithDisabledPropType> = ({
  isBookingDisable,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const showCalendarSection = useSelector(
    (State: RootState) => State.app.showCalendarSection
  );

  const showBookingUserSwitch = () => {
    dispatch(appSlice.actions.changeShowCalendarSection(!showCalendarSection));
  };

  return (
    <div className="fg-booking-toggle-calendar-switch py-3">
      <div className="container">
        <div className="row">
          <div
            className={`col-12 form-tick-wrap ${isBookingDisable && "disabled"}`}
            data-testid="booking-calendar-toggle"
          >
            <div className="switch-group">
              <div className="form-check form-switch mb-0">
                <input
                  className="form-check-input"
                  type="checkbox"
                  role="switch"
                  id="fg-booking-calendar-toggle"
                  onChange={showBookingUserSwitch}
                  checked={showCalendarSection}
                />
                <label className="form-check-label">
                  {t("showBookedCalendar")}
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookingCalendarToggle;
